import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import validator from 'validator';
import { connect } from "react-redux";
import { Col, Table, Button, Input, Modal, Switch, DatePicker } from 'antd';
import { Redirect } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import { UpsertUser, DeleteUserFromGate, GetGateUsers, GetGateTimes } from '../../../store/actions/gateActions'; 
import { Select, MenuItem, FormControl } from '@material-ui/core';
import moment from 'moment';
import 'antd/dist/antd.css';

import StarsIcon from '@material-ui/icons/Stars';
import AccountCircle from '@material-ui/icons/Person';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
const { Option } = Select;
const { RangePicker } = DatePicker;
const { Search } = Input;
const format = 'h:mm a';

function GateUsers(props) {
    const { gate } = props;
    const [isLoading,  setLoading]      = useState(true);
    const [formData,   setFormData]     = useState({ accessTime: 0 });
    const [userList,   setUsers]        = useState([]);
    const [userModal,  showUser]        = useState(false);
    const [userDetail, setUserDetail]   = useState({});
    const [userType,   setUserType]     = useState("");
    const [redirectID, setRedirectID]   = useState("");
    const [searchUser, setSearch]       = useState("");

    useEffect(() => {
        const subUsers = async () => {
            return await props.GetGateUsers(gate_id);
        }
        let unsubUsers = subUsers();
        return async () => {
            let unsubU = await unsubUsers; 
            unsubU();
        };
    },[]);

    useEffect(() => {
        if( isLoading ) {
            if( props.timers.length === 0 ) { 
                //Get Time Data if Loading and No Times has been loaded
                props.GetGateTimes(gate_id);   
            }
            setLoading(false);
        }
    },[]);

    let users = userList;
    let gate_id = window.location.pathname.split("/")[3];
    
    if(searchUser) {
        let search = searchUser.toLowerCase();
        users = userList.filter(user => 
            user.name.toLowerCase().includes(search) ||
            user.phone.toLowerCase().includes(search)
        );
    } else {
        users = _.isEmpty(userList) ? [] : userList;
    }

    useEffect(() => {
        // if( userList.length !== props.users.length ) {
            setUsers(props.users);
        // }
        // console.log(props);
    },[props])

    const disabledDate = current => {
        let now = moment();
        const tooEarly = current && current < moment().subtract("day", 1);
        const tooLate = current && current > moment().add("day", 20);
        return tooEarly || tooLate;
    };

    const SetData = (key,value) => {
        let data = formData;
        data[key] = value;
        setFormData(formData);
    }

    const _error = (message) => {
        setLoading(false);
        alert(message)
        return;
    }

    const RedirectToUser = async (user_id) => {
        setRedirectID(user_id);
    }

    const ReinviteGuest = async (gate_id, user_id) => {
        let response = await fetch(`https://us-central1-maximum-controls-app.cloudfunctions.net/api/v1/gates/${gate_id}/invite/${user_id}`);
        let result = await response.json();
        if ( result.success ) {
            alert("Guest Pass Resent");
        } else {
            alert("There was an error resending the Pass. Try again.")
        }
    }

    const CancelModal = () => {
        setUserType("");
        !_.isEmpty(userDetail) && setUserDetail({});
        if (!isLoading) { 
            setUserType("");
            setUserDetail({}) 
            setFormData({accessTime: 0});  
        }
    }

    //Rename to UpsertItem
    const UpsertItem = async (type, updateData) => { 
        if(!isLoading) {
            setLoading(true); 
            let data = typeof updateData === "undefined" ? formData : updateData ;
            const { name, phone, startTime, expireTime, keycode, wiegand, facility } = data;

            //Name is Required for Everyone
            if (!_.isString(name)) return _error("Username is required");

            if( type === "Guest" || type === "Admin" || phone ) {
                //Phone is Required for Guest and Admin
                if( !_.isString(phone) ) return _error("Phone is required"); 
                
                //Phone is Only Numbers
                if( !validator.isNumeric(phone) ) return _error("Phone must be Numeric");
                
                //Find Duplicate Phone Number
                if( userDetail.phone !== phone ) {
                    let result = userList.find( user => user.phone === phone );
                    if( result ) return _error("Duplicate phone number found on Gate");
                }
                
                if( type !== "Guest" ) {
                    //Grab the User ID
                    const response = await fetch(`https://us-central1-maximum-controls-app.cloudfunctions.net/api/v1/phone/${phone}`);
                    const result   = await response.json();
                    if( !data.id ) {
                        data.newID = result.uid;
                    }
                }
            }
            
            if( type === "Guest" ) {
                //Start Time and End Time required
                data.isGuest = true;
                if( typeof startTime === "undefined" ) return _error("A Start Date is required");
                if( typeof expireTime   === "undefined" ) return _error("A End Date is required");
            }

            if( type === "User" || type === "Admin" ) {
                //Validate Keycode
                if( _.isString(keycode) && keycode.length > 0 ) {
                    //Keycode must be Numeric and be of 5 Numbers
                    if( !validator.isNumeric(keycode) ) return _error("Keycode must be Numeric");
                    if( !validator.isLength( keycode , {min: 5, max: 5}) ) return _error("Keycode must be of 5 Numbers");
                    
                    //Find Duplicate Keycode
                    if( userDetail.keycode !== keycode ) {
                        let result = userList.find( user => user.keycode === keycode );
                        if( result ) return _error("Duplicate Keycode found on Gate");
                    }
                }

                //Validate Wiegand
                //Wiegand found but no Facility
                if( _.isString(wiegand) && !_.isString(facility) ) {
                    return _error("A Facility code is required with Wiegand Code");
                }

                //Facility foound but no Wiegand
                if( !_.isString(wiegand) && _.isString(facility) ) {
                    return _error("A Wiegand code is required with Facility Code");
                }

                if( _.isString(wiegand) && _.isString(facility) && wiegand.length > 0 && facility.length > 0 ) {
                    //Wiegand must be Numeric and be of 5 Numbers
                    if( !validator.isNumeric(wiegand) ) return _error("Wiegand must be Numeric");
                    if( !validator.isLength( wiegand , {min: 5, max: 5}) ) return _error("Wiegand must be of 5 number");
                        
                    //Find Duplicate Wiegand
                    if( (userDetail.id && userDetail.wiegand !== wiegand) || !userDetail.id ) {
                        let result = userList.find( user => user.wiegand === wiegand );
                        if( result ) return _error("Duplicate Wiegand found on Gate");

                        let facility_result = userList.find( user => user.facility === facility );
                        if( facility_result ) return _error("Duplicate Facility Code found on Gate");
                    }
                }
            }

            let result = await props.UpsertUser(gate_id, data);
            if( result ) {
                setFormData({ accessTime: 0 });
                setUserDetail("");
                setUserType("");
                setLoading(false);
                if( userDetail ) alert(`${type.charAt(0).toUpperCase() + type.slice(1)} Updated`);
                else alert(`${type.charAt(0).toUpperCase() + type.slice(1)} Created`);
            }

        }
        
    }
    users = users.sort((a,b) => {
        let item_a = a.name.toUpperCase();
        let item_b = b.name.toUpperCase();
        let comparison = 0;
        if (item_a > item_b) {
            comparison = 1;
        } else if (item_a < item_b) {
            comparison = -1;
        }
        return comparison;
    });

    const UserNav = () => {
        return (
            <div className={"userAdd"}>
                <Button type="primary" onClick={() => setUserType("Admin")}>Add a Admin</Button>
                <Button type="primary" onClick={() => setUserType("User")}>Add a User</Button>
                <Button type="primary" onClick={() => setUserType("Guest")}>Invite a Guest</Button>
                <Modal
                    title={ _.isEmpty(userDetail) ? `Create a ${userType}` : `Update ${userType}`}
                    visible={userType == "User" || userType == "Guest" || userType == "Admin" }
                    className="modalUserAdd"
                    onCancel={CancelModal}
                    footer={
                        <div
                            style={{
                                display: "flex", 
                                justifyContent: !_.isEmpty(userDetail) ? "space-between" : "end"
                            }}
                        >
                            { /* View User Button -> */ !_.isEmpty(userDetail) && !userDetail.isGuest && <Button style={{color: "green", borderColor: "green"}} type="dashed" onClick={() => RedirectToUser(userDetail.id)}>View User</Button>}
                            { /* Reinvite Button -> */ userDetail.isGuest && <Button style={{color: "green", borderColor: "green"}} onClick={() => ReinviteGuest(gate_id,userDetail.id)} type="dashed">Resend Invite</Button>}
                            <span>
                                { !_.isEmpty(userDetail) && <Button // Delete Button
                                    onClick={() => {
                                        var confirmDelete;
                                        if(confirmDelete = prompt("Type DELETE in all Caps to confirm removal")) {
                                            if( confirmDelete === "DELETE" ) {
                                                props.DeleteUser(gate_id, userDetail.id);
                                                CancelModal();
                                                alert(`${userType} has been Delete`);
                                            } else if( confirmDelete.length > 0 ) {
                                                alert("Please type CONFIRM in all caps to delete");
                                            }
                                        }
                                    }}
                                    danger type="link">
                                        Delete
                                </Button> }
                                <Button onClick={CancelModal}>Cancel</Button>
                                <Button //Update|Create button
                                    type="primary"
                                    loading={isLoading}
                                    onClick={ () => {
                                        if( _.isEmpty(userDetail) ) { //Create
                                            userType == "Admin" && SetData("isAdmin", true);
                                            userType == "Guest" && SetData("isGuest", true);
                                            !isLoading && UpsertItem(userType);
                                        } else { //Update
                                            let updateData = { ...userDetail, ...formData};
                                            !isLoading && UpsertItem(userType, updateData);
                                        }
                                    }}
                                >
                                    {!_.isEmpty(userDetail) 
                                    ? `Update ${userType}` 
                                    : `${userType === "Guest" 
                                        ? "Invite" : "Create"} ${userType}` }
                                </Button>
                            </span>
                        </div>
                    }
                >
                    <TextField 
                        variant="outlined" 
                        onChange={e => SetData("name", e.target.value)} 
                        fullWidth name="name" 
                        label={`${userType} Name`} 
                        defaultValue={ _.isEmpty(userDetail) ? formData.name : userDetail.name } 
                    />
                    <TextField 
                        variant="outlined" 
                        onChange={e => SetData("phone", e.target.value)} 
                        fullWidth 
                        name="phone" 
                        label="Cell Phone #" 
                        defaultValue={ _.isEmpty(userDetail) ? formData.phone : userDetail.phone }
                    />
                    {(userType === "User" || userType === "Admin")
                    && <TextField 
                        variant="outlined" 
                        onChange={e => SetData("keycode", Math.max(0, parseInt(e.target.value) ).toString().slice(0,5))} 
                        fullWidth 
                        name="keycode" 
                        label="Keycode"
                        inputProps={{maxLength: 5}}
                        defaultValue={ _.isEmpty(userDetail) ? formData.keycode : userDetail.keycode }
                    />}
                    {(userType === "User" || userType === "Admin")
                    && <div>
                        <TextField 
                            style={{ width: "30%", marginRight: "15px" }}
                            variant="outlined" 
                            onInput={e => SetData("facility", Math.max(0, parseInt(e.target.value) ).toString().slice(0,3))} 
                            name="facility"
                            inputProps={{maxLength: 3}}
                            label="Facility Code" 
                            defaultValue={ _.isEmpty(userDetail) ? formData.facility : userDetail.facility }
                        />
                        <TextField 
                            style={{ width: "65%" }}
                            variant="outlined" 
                            onInput={e => SetData("wiegand", Math.max(0, parseInt(e.target.value) ).toString().slice(0,5))} 
                            name="wiegand" 
                            label="Wiegand Code" 
                            inputProps={{maxLength: 5}}
                            defaultValue={ _.isEmpty(userDetail) ? formData.wiegand : userDetail.wiegand }
                        />
                    </div>}
                    {(userType === "User" || userType === "Guest")
                    && <FormControl variant="outlined" style={{width: "100%"}}>
                        <Select 
                            onClick={(e) => SetData("accessTime",e.target.value)} 
                            defaultValue={ _.isEmpty(userDetail.accessTime) ? 0 : userDetail.accessTime }
                        >
                            {props.timers.map((time,i) => 
                                <MenuItem key={i} value={i}>{time.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>}
                    {userType == "Guest" && 
                        <RangePicker 
                            disabledDate={disabledDate} 
                            format={"MMMM DD"} 
                            defaultValue={_.isEmpty(userDetail) 
                                ? [formData.startTime,formData.expireTime] 
                                : [moment(new Date(userDetail.startTime)),moment(new Date(userDetail.expireTime))]
                            } 
                            size="large" 
                            onChange={(dates) => { 
                                SetData("startTime",dates[0]); 
                                SetData("expireTime",dates[1]); 
                            }} 
                        /> 
                    }
                    {userType == "Admin" && <div className="switch">
                        <span>Text on Gate Opening</span>
                        <Switch defaultChecked={ formData.textOnOpen || userDetail.textOnOpen} onChange={value => SetData("textOnOpen", value)} />
                    </div>}
                    {userType == "Admin" && <div className="switch">
                        <span>Text on Gate Tamper</span>
                        <Switch defaultChecked={  formData.textOnTamper || userDetail.textOnTamper} onChange={value => SetData("textOnTamper", value)}/>
                    </div>}
                    {userType == "Admin" && <div className="switch">
                        <span>Text on Gate Safety Sensor Failure </span>
                        <Switch defaultChecked={ formData.textOnSensorFail || userDetail.textOnSensorFail} onChange={value => SetData("textOnSensorFail", value)}/>
                    </div>}
                    {(userType == "Admin" || userType === "User") && <div className="switch">
                        <span>Is a Gate Admin</span>
                        <Switch 
                            defaultChecked={ 
                                !userDetail.id && userType == "Admin" 
                                ? true 
                                : formData.isAdmin == false && userDetail.isAdmin == true 
                                    ? false 
                                    : formData.isAdmin 
                                        ? true 
                                        : userDetail.isAdmin
                                            ? true
                                            :false
                            } 
                            onChange={value => { 
                                SetData("isAdmin", value);
                                if( userType == "Admin" ) {
                                    setUserType("User");
                                } else { 
                                    setUserType("Admin");
                                }
                            }
                        }/>
                    </div>}
                </Modal>
            </div>
        );
    }

    if (redirectID !== "") {
        return <Redirect push to={`/admin/user/${redirectID}`} />;
    }

    if(users.length === 0) 
        return (
            <div className="container gateDetail">
                <div className="row" style={{marginTop: "25px", marginBottom: "0"}}>
                    <UserNav />
                    <div className="col s6">
                        <div className="col s12">
                            No Users yet.
                        </div>
                    </div>
                </div>
            </div>
        );

    const columns = [
        {
            title: '',
            dataIndex: 'isAdmin',
            width: '5%',
            key: 'userType',
            render: (isAdmin, record) => ( <span>{isAdmin ? <StarsIcon style={{color: "red"}} /> : record.isGuest ? <AssignmentIndIcon style={{color: "blue"}}/> : <AccountCircle style={{color: "black"}}/> }</span> ),
        },
        {
            title: 'Name',
            dataIndex: 'name',
            width: '30%',
            key: 'name'
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            render: (phone) => formatPhoneNumber(phone),
            width: '20%',
            key: 'phone'
        },
        {
            title: 'Keycode',
            dataIndex: 'keycode',
            width: '20%',
            key: 'keycode',
        },
        {
            title: 'Wiegand',
            dataIndex: 'wiegand',
            width: '20%',
            key: 'wiegand',
            render: (text, record) => ( <span>{record.facility && text ? `${record.facility}-${text}` : ""}</span> ),
        },
        // {
        //     title: 'Access Time',
        //     dataIndex: 'accessTime',
        //     width: '10%',
        //     key: 'accessTime'
        // },
    ];

    users = users.map((user, i) => {
        user.key = i;
        return user;
    });

    return (
        <div className="col s6">
            <Col span={24}>
                <div className="gateUserActions">
                    <UserNav/>
                    <Search
                        placeholder="Search"
                        enterButton="Search"
                        size="large"
                        onSearch={value => setSearch(value)}
                        style={{ width: 335 }}
                    />
                </div>
                <Table
                    columns={columns}
                    dataSource={users}
                    rowKey={user => user.id}
                    loading={isLoading}
                    pagination={{ pageSize: 12 }}
                    onRow={(record, rowIndex) => {
                        return { 
                            onClick: () => {
                                const { isGuest, isAdmin } = record;
                                setFormData({});
                                setUserDetail(record);
                                if( isGuest )      setUserType("Guest");
                                else if( isAdmin ) setUserType("Admin");
                                else               setUserType("User");
                            } 
                        }
                    }}
                />
            </Col>
        </div>
    );
}


const mapStateToProps = (state) => {
    return {
        gate:    state.gate.gate,
        timers:  state.gate.times,
        users:   state.gate.users
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        UpsertUser:  (gate_id, data) => dispatch( UpsertUser(gate_id, data)),
        GetGateUsers:     (gate_id) => dispatch(GetGateUsers(gate_id)),
        GetGateTimes:     (gate_id) => dispatch(GetGateTimes(gate_id)),
        DeleteUser:  (gate_id, data) => dispatch( DeleteUserFromGate(gate_id, data)),
    }
}

function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return null
  }

export default connect(mapStateToProps, mapDispatchToProps)(GateUsers);
